const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment');


app.controller('overviewSurveys', ['Application', 'AccessHelper', 'Analyze', 'Surveys', '$scope', '$translate', function(Application, AccessHelper, Analyze, Surveys, $scope, $translate) {
    var self = this;
    self.features = Application.features.flags();
    self.allowance = {
        surveys: self.features.surveys && AccessHelper.isAllowed(['admin', 'surveys'], null, ['admin'])
    };

    if (!self.allowance.surveys || Application.access.role !== 'admin') {
        Application.navigation.goTo('/explore');
        return;
    }

    self.loading = true;

    // TODO: delete functionality
    self.surveySelectedToArchive = null;
    self.showArchiveModal = false;

    self.requestDelete = function(survey) {
      self.surveySelectedToArchive = survey;
      self.showArchiveModal = true;
    }

    self.cancelArchive = function() {
      self.showArchiveModal = false;
      self.surveySelectedToArchive = null;
    }

    self.archive = async function() {
      try {
        await Surveys.archive({subsubresource: self.surveySelectedToArchive._id}, {archived: true}).$promise;
        self.showArchiveModal = false;
        Application.messaging.addMessage({type: 'success', duration: 6, text: self.translations['edit.surveys.archiveSuccess']});
        self.editMenu.closeHandler();
        self.surveySelectedToArchive = null;
        checkForSearchAndLoad();
      } catch (e) {
        console.log(e);
        self.showArchiveModal = false;
        Application.messaging.addMessage({type: 'error', duration: 6, text: self.translations['edit.surveys.archiveError']});
        self.editMenu.closeHandler();
        self.surveySelectedToArchive = null;
      }
      $scope.$apply();
    }

    self.unarchive = async function(surveyId) {
      try {
        await Surveys.archive({subsubresource: surveyId}, {archived: false}).$promise;
        self.editMenu.closeHandler();
        Application.messaging.addMessage({type: 'success', duration: 6, text: self.translations['edit.surveys.unarchiveSuccess']});
        checkForSearchAndLoad();
      } catch (e) {
        console.log(e);
        self.editMenu.closeHandler();
        Application.messaging.addMessage({type: 'error', duration: 6, text: self.translations['edit.surveys.unarchiveError']});
      }
      $scope.$apply();
    }

    self.search = {
      existingQuery: () => {
        return !!Object.keys(self.search.query).length;
      },
      query: {},
      onQuery: function(items) {
        self.search.query = {};
        let survey = '';
        let text = '';
        items.forEach(item => {
          if (item._id) {
            survey = item._id;
          } else {
            text = item.title;
          }
        })

        if (survey.length) {
          this.query._id = survey;
        }
        if (text.length) {
          this.query.term = text
        }

        self.paginate.page = 0;
        self.load(self.search.query);
      },
    }

    // editMenu
    self.editMenu = {
      visible: false,
      activeId: null,
      closeHandler: function(){
        self.editMenu.visible = false;
        self.editMenu.activeId = null;
      },
      clickHandler: function(i){
        if (self.editMenu.visible) {
          if (self.editMenu.activeId === i) {
            self.editMenu.visible = false;
            self.editMenu.activeId = null;
          } else {
            self.editMenu.activeId = i;
          }
        } else {
          self.editMenu.activeId = i;
          self.editMenu.visible = true;
        }
      }
    };

    self.navigation = {
      currentTab: 'active',
      changeTab: function(tab) {
        if (tab !== self.navigation.currentTab) {
          self.navigation.currentTab = tab;
          self.paginate.page = 0;
          checkForSearchAndLoad(); 
        }
      }
    }

    self.stats = {
      totalSurveys: 0,
      totalSubmissions: 0,
      totalViews: 0
    }


    // Pagination

    self.paginate = {
      perPage: 10,
      page: 0,
      emptyPage: false,
      nextPage: function () {
        this.page++;
        checkForSearchAndLoad();
      },
      previousPage: function () {
        if (this.emptyPage) {
          this.emptyPage = false;
        }
        this.page--;
        checkForSearchAndLoad();
      }
    }

    self.load = async function(query = {}) {
      try {
        const queryWithArchive = {...query, archived: self.navigation.currentTab === 'archived'};
        const surveyList = await Surveys.list({
          page: self.paginate.page,
          perPage: self.paginate.perPage,
          query: queryWithArchive
        }).$promise;
        if (surveyList.length < self.paginate.perPage) {
          self.paginate.emptyPage = true;
        }
        if (surveyList.length === self.paginate.perPage) {
          self.paginate.emptyPage = false;
        }
        self.surveys = surveyList;
        self.loading = false;
        $scope.$apply();
     } catch (err) {
        console.error('Error retrieving Surveys', err);
     }
    }

    const checkForSearchAndLoad = function() {
      if (self.search.existingQuery()) {
        self.load(self.search.query);
      } else {
        self.load();
      }
    }

    $translate([
      'edit.surveys.archiveSuccess',
      'edit.surveys.archiveError',
      'edit.surveys.unarchiveSuccess',
      'edit.surveys.unarchiveError',
      'surveyStats.totalViews',
      'surveyStats.totalSurveys',
      'surveyStats.totalSubmissions',
      'overviewContent.past_30_days',
      'overviewContent.added_in_total'
    ]).then(async function(translations) {
      self.translations = translations;
      const stats = await Surveys.count().$promise;
      const viewQuery = {content_type: 'survey', created_at: {gte: moment().subtract(30, 'days').toDate()}}
      const views = await Analyze.viewCount(viewQuery).$promise;
      self.stats.totalSurveys = stats.totalSurveys;
      self.stats.totalSubmissions = stats.totalSubmissions;
      self.stats.totalViews = views.count;
      self.load();
    });


}]);